import { useMemo } from "react"

import { NETWORK_ERROR_MESSAGE } from "modules/BookingCommon/common/constants"
import { UserAccountData } from "utils/interfaces"
import { useBookingApi, useSkipPayment } from "modules/Booking/FormPage/common/hooks"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { useBookingContext } from "modules/Booking/BookingContext"
import { CURRENCY } from "utils/constants"
import { paymentButtonText } from "modules/Booking/FormPage/common"
import { Button } from "ui-kit/components-branded/index"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"

interface Props {
    formHasErrors: boolean
    showErrors(): void
    userData: UserAccountData
}

export function NextPageButton({ userData, formHasErrors, showErrors }: Props) {
    const [{ form }] = useFormPageContext()
    const [{ currency, errorMessage, sessionType }] = useBookingContext()

    const onlyFree = useOnlyFreeSessions()
    const skipPayment = useSkipPayment()
    const { handleClickButton, isLoading } = useBookingApi(userData)

    const isAutoPay = useMemo(() => {
        return !!form.payByCard?.external_id && currency === CURRENCY.RUB && !skipPayment
    }, [form.payByCard?.external_id, currency, skipPayment])

    const handleSubmit = () => {
        if (formHasErrors) {
            showErrors()
            return
        }
        handleClickButton(form.payByCard?.external_id, isAutoPay)
    }

    return (
        <>
            <Button color="primary" isFullwidth onClick={handleSubmit} isLoading={isLoading}>
                {paymentButtonText(sessionType, onlyFree, skipPayment, isAutoPay)}
            </Button>
            {errorMessage && (
                <div className="booking__error-text">{errorMessage || NETWORK_ERROR_MESSAGE}</div>
            )}
        </>
    )
}
